export const ENTITY_TYPE_INTEGRATION = 'Integration';

export const ENTITY_TYPE_SUBSCRIPTION = 'Subscription';

export const PENDO_INTERNAL_SUB = '5668600916475904';

export const SOURCE_INTEGRATION = 'integration';

export const STATUS_CONFIGURED = 'configured';

export const INTEGRATION_OAUTH_STATUSES = {
    error: 'ERROR',
    ok: 'OK',
    pending: 'PENDING',
};

export const OAUTH_STATUSES = {
    authenticated: 'Authenticated',
    error: 'Error',
    pending: 'Pending',
    unauthenticated: 'Unauthenticated',
};
